import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import BuyOnStoreButton from "web/react/components/buy-on-store-button/buy-on-store-button";
import Expandable from "web/react/components/expandable/expandable";
import PriceInfo from "web/react/components/price-info/price-info";
import SizePicker from "web/react/components/size-picker/size-picker";
import Shipping from "web/react/components/shipping/shipping";
import { gettext } from "web/script/modules/django-i18n";
import { ShippingOptionPropType, SizePropType } from "web/types/buy-option";
import styles from "./comparison-option.css";

function ComparisonOption(_ref) {
  var allSizesSorted = _ref.allSizesSorted,
      buyOptionSizes = _ref.buyOptionSizes,
      className = _ref.className,
      shouldDisplaySizes = _ref.shouldDisplaySizes,
      formattedPrice = _ref.formattedPrice,
      freeReturn = _ref.freeReturn,
      isAlternativeOption = _ref.isAlternativeOption,
      isInStock = _ref.isInStock,
      leadUrl = _ref.leadUrl,
      onSale = _ref.onSale,
      productId = _ref.productId,
      retailerName = _ref.retailerName,
      salePrice = _ref.salePrice,
      shippingOptions = _ref.shippingOptions;

  /*
      in the main price area we need html from the backend. for the price comparison we don't need this
  */
  var currentPriceHtml = onSale ? salePrice : formattedPrice;
  var selectedShipping;
  var freeShipping;
  var expressShipping;

  if (shippingOptions) {
    var cheapest = shippingOptions.cheapest,
        guaranteed = shippingOptions.cheapest_guaranteed,
        fastest = shippingOptions.fastest;

    if (cheapest && cheapest.is_free) {
      freeShipping = cheapest;
    }

    if (guaranteed) {
      selectedShipping = guaranteed;
    } else {
      selectedShipping = cheapest;
    }

    expressShipping = fastest;
  }

  var shouldRenderShipping = freeShipping || expressShipping || freeReturn;
  className = classnames(className, styles.wrapper);
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: styles.content
  }, React.createElement("div", {
    className: styles.left
  }, React.createElement(PriceInfo, {
    currentPriceHtml: currentPriceHtml,
    formattedPrice: formattedPrice,
    isInStock: isInStock,
    isOnSale: onSale,
    leadUrl: leadUrl,
    retailerName: retailerName,
    selectedShipping: selectedShipping
  })), React.createElement("div", {
    className: styles.button
  }, isInStock ? React.createElement(BuyOnStoreButton, {
    productId: productId,
    leadUrl: leadUrl,
    reason: isAlternativeOption ? "buy-on-store-alternative-option" : undefined
  }) : React.createElement("span", {
    className: styles.oosText
  }, gettext("in_stock_product.compare_prices.out_of_stock_option") // "Out of stock"
  ))), shouldDisplaySizes && allSizesSorted && React.createElement("div", {
    className: styles.subarea
  }, React.createElement("h3", {
    className: styles.subtitle
  }, gettext("in_stock_product.sizes.title"), ":"), React.createElement(SizePicker, {
    buyOptionSizes: buyOptionSizes,
    allSizesSorted: allSizesSorted
  })), shouldRenderShipping && React.createElement(Expandable, {
    className: styles.expandable,
    renderLabel: function renderLabel() {
      return React.createElement("span", {
        className: styles.expandableLabel
      }, gettext("in_stock_product.compare_prices.all_shipping_returns.link"));
    },
    chevronClass: styles.expandableChevron
  }, React.createElement(Shipping, {
    expressShipping: expressShipping,
    freeReturn: freeReturn,
    freeShipping: freeShipping,
    leadUrl: leadUrl,
    retailerName: retailerName
  })));
}

export default ComparisonOption;
ComparisonOption.propTypes = {
  allSizesSorted: PropTypes.array,
  buyOptionSizes: PropTypes.objectOf(SizePropType),
  className: PropTypes.string,
  shouldDisplaySizes: PropTypes.bool,
  formattedPrice: PropTypes.string.isRequired,
  freeReturn: PropTypes.bool.isRequired,
  isAlternativeOption: PropTypes.bool.isRequired,
  isInStock: PropTypes.bool.isRequired,
  leadUrl: PropTypes.string.isRequired,
  onSale: PropTypes.bool.isRequired,
  productId: PropTypes.string.isRequired,
  retailerName: PropTypes.string.isRequired,
  salePrice: PropTypes.string,
  shippingOptions: PropTypes.objectOf(ShippingOptionPropType)
};